import Vue from 'vue'
import App from './App.vue'
import { VueAxios } from './api/request'
import store from './store'
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import Viser from 'viser-vue'

import dataV from '@jiaminghi/data-view'

import './css/index.css'


// 宽度自适应
// import 'amfe-flexible'

Vue.use(dataV)
Vue.use(Viser)
Vue.use(Antd);
Vue.use(VueAxios)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
